export const scroll = {
  library: 'asscroll',
  containerParent: "[data-scroll-container]",
  container: "[data-scroll-inner]",
  options: {
    ease: .115,
    disableOnTouch: true
  },
}